import { Controller } from "stimulus"

const POINTER_OFFSET = 15
const FOCUS_OFFSET = 12

export default class extends Controller {
  static targets = ["svg"]

  positionFromPointer(event) {
    const point = this.svgPoint(event.clientX, event.clientY)
    if (!point) return

    this.positionDetails(event.currentTarget, point, POINTER_OFFSET)
  }

  positionFromFocus(event) {
    const shape = event.currentTarget.querySelector(".national-state-map__hit-area")
    if (!shape) return

    const bounds = shape.getBBox()
    this.positionDetails(event.currentTarget, {
      x: bounds.x + (bounds.width / 2),
      y: bounds.y + (bounds.height / 2)
    }, FOCUS_OFFSET)
  }

  positionDetails(link, anchor, offsetInPixels) {
    const details = link.querySelector(".national-state-map__details")
    if (!details) return

    const viewBox = this.svgTarget.viewBox.baseVal
    const width = Number(details.getAttribute("width"))
    const height = Number(details.getAttribute("height"))
    const scale = this.screenScale()
    const offset = {
      x: offsetInPixels / scale.x,
      y: offsetInPixels / scale.y
    }

    details.setAttribute("x", this.clampedPosition(anchor.x, width, offset.x, viewBox.x, viewBox.width))
    details.setAttribute("y", this.clampedPosition(anchor.y, height, offset.y, viewBox.y, viewBox.height))
  }

  clampedPosition(anchor, size, offset, origin, extent) {
    const maximum = origin + extent - size
    const following = anchor + offset
    const preferred = following + size <= origin + extent ? following : anchor - offset - size

    return Math.min(Math.max(preferred, origin), maximum)
  }

  svgPoint(clientX, clientY) {
    const matrix = this.svgTarget.getScreenCTM()
    if (!matrix) return null

    const point = this.svgTarget.createSVGPoint()
    point.x = clientX
    point.y = clientY
    return point.matrixTransform(matrix.inverse())
  }

  screenScale() {
    const matrix = this.svgTarget.getScreenCTM()

    return {
      x: matrix ? Math.hypot(matrix.a, matrix.b) : 1,
      y: matrix ? Math.hypot(matrix.c, matrix.d) : 1
    }
  }
}
